import { render, staticRenderFns } from "./DialogView.vue?vue&type=template&id=0be5aeaa&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"
import style0 from "./DialogView.vue?vue&type=style&index=0&id=0be5aeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5aeaa",
  null
  
)

export default component.exports